import { SWIPE_CONFIG } from '../constants/gameConstants';

export function handleTouchStart(event, setTouchStart) {
  const touch = event.touches[0];
  setTouchStart({
    x: touch.clientX,
    y: touch.clientY,
    time: Date.now()
  });
}

export function handleTouchMove(event) {
  // Prevent scrolling when swiping
  event.preventDefault();
}

export function handleTouchEnd(event, touchStart, setTouchStart, moveBoard) {
  if (!touchStart) return;

  const touch = event.changedTouches[0];
  const touchEnd = {
    x: touch.clientX,
    y: touch.clientY,
    time: Date.now()
  };

  const deltaTime = touchEnd.time - touchStart.time;
  const deltaX = touchEnd.x - touchStart.x;
  const deltaY = touchEnd.y - touchStart.y;

  // Reset touch start
  setTouchStart(null);

  // Check if swipe was quick enough
  if (deltaTime > SWIPE_CONFIG.maxTime) return;

  // Calculate absolute distances
  const absX = Math.abs(deltaX);
  const absY = Math.abs(deltaY);

  // Check if swipe was long enough
  if (absX < SWIPE_CONFIG.minDistance && absY < SWIPE_CONFIG.minDistance) return;

  // Determine swipe direction
  if (absX > absY) {
    // Horizontal swipe
    if (deltaX > 0) {
      moveBoard('right');
    } else {
      moveBoard('left');
    }
  } else {
    // Vertical swipe
    if (deltaY > 0) {
      moveBoard('down');
    } else {
      moveBoard('up');
    }
  }
}